import { analystForecasts } from './analystForecasts';
import { technicalAnalysis } from './technicalAnalysis';
import { economicCalendar } from './economicCalendar';

export const tipRanksConfig = process.env.NEXT_PUBLIC_TIP_RANKS

export {
    technicalAnalysis,
    economicCalendar,
    analystForecasts,
};